import './style.css';

export const Input = ({ 
    value,
    onChange,
    onFocus,
    onBlur,
    className,
    type,
    name,
    label,
    required = null,
    pattern = null
}) => {
    return !pattern ? (
        <div className="form-item">
            <input
                className={className}
                type={type}
                name={name}
                value={value}
                required={required === 'required'}
                onChange={onChange}
                onFocus={onFocus}
            />
            <label htmlFor="">{label}</label>
        </div>
    ) : (
        <div className="form-item">
            <span 
                className="field-info" 
                data-toggle="tooltip" 
                data-placement="top" 
                title="Sono accettati solamente numeri di telefono italiani">
            </span>
            <input
                className={className}
                type={type}
                name={name}
                value={value}
                required={required === 'required'}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                pattern={pattern}
            />
            <label htmlFor="">{label}</label>
        </div>
    );
}